<template>
  <div>
    <a-spin :spinning="loading">
      <div class="row" v-if="data && data.length > 0">
        <!-- Student Name List Sidebar -->
        <div class="col-md-3 col-12 mb-3">
          <div class="student-list-sidebar">
            <div class="student-list-header">
              <strong>Students ({{ data.length }})</strong>
            </div>
            <div class="student-list-container">
              <div
                v-for="student in data"
                :key="'list-' + student.id"
                class="student-list-item"
                :class="{ 'student-list-item-active': activeStudentKey === String(student.id) }"
                @click="selectStudent(student.id)"
              >
                <div class="student-list-name">{{ student.first_name }} {{ student.last_name }}</div>
                <div class="student-list-info">
                  <small class="text-muted">
                    {{ student.student_code }}
                    <span v-if="student.enrollment && student.enrollment[0]">
                      &middot; {{ student.enrollment[0].school_class ? student.enrollment[0].school_class.name : '' }}
                      {{ student.enrollment[0].section ? student.enrollment[0].section.name : '' }}
                    </span>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Tabs + Camera/Photo Area -->
        <div class="col-md-9 col-12">
          <div class="neo-tabs-fees">
            <a-tabs
              :tabPosition="settings['isMobileView'] ? 'top' : 'top'"
              :activeKey="activeStudentKey"
              @change="handleStudentChange"
            >
              <a-tab-pane
                v-for="student in data"
                :tab="`${student.first_name} ${student.last_name} (${student.student_code}) ${student.enrollment[0].school_class ? student.enrollment[0].school_class.name : ''} ${student.enrollment[0].section ? student.enrollment[0].section.name : ''}`"
                :key="String(student.id)"
                :forceRender="true"
              >
                <neo-camera :data="student" @updated="handlePhotoUpdate" />
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </div>
      <div v-else-if="!loading">
        <a-empty description="No students found" />
      </div>
    </a-spin>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import NeoCamera from './partials/NeoCamera'
export default {
  name: 'StudentPhotoUpload',
  props: ['data', 'loading', 'session'],
  components: {
    NeoCamera,
  },
  data: function() {
    return {
      activeStudentKey: null,
    }
  },
  computed: {
    ...mapState(['settings']),
  },
  watch: {
    data: {
      handler(newData) {
        // When data loads or changes, select the first student if none is selected
        if (newData && newData.length > 0) {
          const currentIds = newData.map(s => String(s.id))
          if (!this.activeStudentKey || !currentIds.includes(this.activeStudentKey)) {
            this.activeStudentKey = String(newData[0].id)
          }
        } else {
          this.activeStudentKey = null
        }
      },
      immediate: true,
    },
  },
  methods: {
    handlePhotoUpdate() {
      this.$emit('updateTable')
    },
    handleStudentChange(key) {
      this.activeStudentKey = key
    },
    selectStudent(studentId) {
      this.activeStudentKey = String(studentId)
    },
  },
}
</script>

<style scoped>
.student-list-sidebar {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background: #fff;
}
.student-list-header {
  padding: 10px 14px;
  border-bottom: 1px solid #e8e8e8;
  background: #fafafa;
}
.student-list-container {
  max-height: 500px;
  overflow-y: auto;
}
.student-list-item {
  padding: 8px 14px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
}
.student-list-item:hover {
  background-color: #e6f7ff;
}
.student-list-item-active {
  background-color: #e6f7ff;
  border-left: 3px solid #1890ff;
}
.student-list-name {
  font-weight: 600;
  font-size: 13px;
  color: #333;
}
.student-list-info {
  margin-top: 2px;
}
</style>
